import { render, staticRenderFns } from "./SmsBroadcastFooter.vue?vue&type=template&id=fdb2142e&scoped=true"
import script from "./SmsBroadcastFooter.vue?vue&type=script&lang=js"
export * from "./SmsBroadcastFooter.vue?vue&type=script&lang=js"
import style0 from "./SmsBroadcastFooter.vue?vue&type=style&index=0&id=fdb2142e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb2142e",
  null
  
)

export default component.exports